

























import Vue, { PropType } from 'vue';
import { EColumnType, TTableColumn } from '@/components/table/types';
import {
  formatNumberByFixed,
  formatNumberByOffset,
  numberIsInt,
} from '@/helpers/dataHelpers';
import { EMPTY_TABLE_BODY_CELL } from '@/configs/tableConfigs';

export default Vue.extend({
  name: 'TableBodyCell',

  props: {
    data: {
      type: [String, Number],
      required: false,
      default: EMPTY_TABLE_BODY_CELL,
    },
    column: {
      type: Object as PropType<TTableColumn>,
      required: true,
    },
  },

  computed: {
    columnTypes(): typeof EColumnType {
      return EColumnType;
    },
    checkDataValueIsExist(): string | boolean {
      if (
        this.data === EMPTY_TABLE_BODY_CELL ||
        this.data === '' ||
        this.data === null
      ) {
        return EMPTY_TABLE_BODY_CELL;
      }
      return false;
    },
    emptyTableBodyCell(): string {
      return EMPTY_TABLE_BODY_CELL;
    },
  },

  methods: {
    formatNumber(value: number): string {
      if (numberIsInt(value)) {
        return formatNumberByOffset(value);
      } else {
        return formatNumberByFixed(value);
      }
    },
  },
});
